/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Learningreport1Inputs */

const zh_learn_learningreport1 = /** @type {(inputs: Learn_Learningreport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 学习报告`)
};

const en_learn_learningreport1 = /** @type {(inputs: Learn_Learningreport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Learning Report`)
};

const es_learn_learningreport1 = /** @type {(inputs: Learn_Learningreport1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe de aprendizaje IA`)
};

/**
* | output |
* | --- |
* | "AI Learning Report" |
*
* @param {Learn_Learningreport1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_learningreport1 = /** @type {((inputs?: Learn_Learningreport1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Learningreport1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_learningreport1(inputs)
	if (locale === "en") return en_learn_learningreport1(inputs)
	return es_learn_learningreport1(inputs)
});
export { learn_learningreport1 as "learn_learningReport" }